import { useCurrentUser } from '~/src/common/user';

import { calculateIsEligibleForFreeTrial } from './calculateIsEligibleForFreeTrial';

export function useIsEligibleForFreeTrial() {
  const { currentUser, loading } = useCurrentUser();

  return {
    isEligibleForFreeTrial: calculateIsEligibleForFreeTrial(currentUser),
    loading,
  };
}
